import React from 'react'
import { withRouteData, Head } from 'react-static'
import Markdown from 'react-markdown'

const Comments = ({ page }) => [
  <Head key="comments-head">
    <title>{page.data.title}</title>
    <meta name="description" content={`${page.data.description}`} />
    <style>{`
      body {
        background-image: url('${page.data.backgroundImage}');
        background-size: cover;
        background-attachment: fixed;
      }
    `}
    </style>
  </Head>,
  <div key="comments-content" className="page-content">
    <Markdown source={page.content} escapeHtml={false} />
    {page.data.comments && page.data.comments.map((comment, index) => (
      <p className="comment" key={`${comment.comment}-${index}`}>{comment.comment}</p>
    ))}
  </div>,
]

const commentsWithRouteData = withRouteData(Comments)

export default commentsWithRouteData



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Comments.js